export const selectPlantsData = (state) => state.plant?.data || [];
export const selectPlantsLoading = (state) => state.plant?.loading || false;
export const selectPlantsError = (state) => state.plant?.error || null;
export const selectSelectedPlant = (state) => state.plant?.selectedPlant || null;
export const selectPlantMaintenanceRecordsData = (state) => state.plant?.maintenanceRecords || [];
export const selectMaintenanceRecordData = (state) => state.plant?.selectedMaintenanceRecord || null;
export const selectPlantMaintenanceData = (state) => state.plant?.maintenanceData || null;
export const selectCellHistoryData = (state) => state.plant?.cellHistoryData || [];

